import { ParallaxScene, ParallaxLayer } from "../ParallaxScene";
import { FloatingGlassPanel } from "../FloatingGlassPanel";
import { heroChips } from "../../data/demoContent";
import { useIsDesktop, useMediaQuery } from "../../hooks/useMedia";
import { scrollToId, focusWaitlist } from "../../lib/scroll";
import { HeroCopy } from "./HeroCopy";

const Chips = () => {
  const xl = useMediaQuery("(min-width: 1280px)");
  return (
    <div className="pointer-events-none absolute inset-0 z-20" aria-hidden data-testid="hero-chips">
      {heroChips
        .filter((ch) => xl || !ch.xlOnly)
        .map((ch, i) => (
          <div key={ch.id} className="absolute" style={ch.style}>
            <ParallaxLayer y={ch.speed}>
              <div className="hero-chip-float reveal" style={{ animationDelay: `${0.5 + i * 0.12}s` }}>
                <FloatingGlassPanel chip={ch} />
              </div>
            </ParallaxLayer>
          </div>
        ))}
    </div>
  );
};

export default function Hero() {
  const desktop = useIsDesktop();
  return (
    <ParallaxScene
      id="experience"
      data-testid="hero-section"
      className="relative flex min-h-[100svh] items-center overflow-hidden pb-24 pt-24 lg:min-h-[max(100vh,720px)] lg:pb-28 lg:pt-20"
    >
      <ParallaxLayer y={180} className="absolute inset-0" aria-hidden>
        <div className="hero-bg ambient-drift absolute" />
      </ParallaxLayer>
      <div className="hero-fade pointer-events-none absolute inset-x-0 bottom-0 z-[15] h-48" aria-hidden />
      {desktop && <Chips />}
      <ParallaxLayer y={desktop ? -240 : 0} fade={0} className="pointer-events-none relative z-30 w-full">
        <HeroCopy onPrimary={focusWaitlist} onSecondary={() => scrollToId("stories")} />
      </ParallaxLayer>
    </ParallaxScene>
  );
}
